<template>
  <v-row
    class="mt-2 mb-6 align-center headline-standard border-bottom border-top"
  >
    <v-col class="col-4">
      {{ title }}
    </v-col>

    <v-col class="col-4 text-center">
      {{ dateFormated | formatDate('dddd, DD.MM.YYYY') }}
    </v-col>

    <!-- logo -->
    <v-col class="col-4 text-right">
      <img
        v-if="$store.getters.getAppDestinationInstance()"
        class="destination-logo"
        :src="$store.getters.getCurrentDestinationInstance().getLogo()"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'SingleReportHeader',

  props: {
    title: {
      type: String,
      required: false,
      default: null,
    },

    date: {
      type: String,
      required: true,
    },
  },

  computed: {
    dateFormated() {
      return new Date(this.date)
    },
  },
}
</script>
